import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import Clock from "../components/icons/Clock";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";
import { routes } from "../routes";

const StartPage = () => {
	const navigate = useNavigate();
	return (
		<LoggedInLayout>
			<Styles>
				<PageTitle>Översikt</PageTitle>

				<div className="tile-row">
					<div className="tile kpi" style={{ backgroundColor: "#e4f3ea" }} onClick={() => navigate(routes.jobs)}>
						<div className="fig-row">
							<div className="fig">
								<Briefcase26 />
							</div>
							<h2>Uppdrag</h2>
						</div>
						<p>
							Det finns <strong>2</strong> bokade uppdrag och <strong>1</strong> uppdrag som ska tillsättas.
						</p>
					</div>
					<div className="tile kpi" onClick={() => navigate(routes.jobApplications)}>
						<div className="fig-row">
							<div className="fig">
								<PersonalTrainer />
							</div>
							<h2>Ansökningar</h2>
						</div>
						<p>
							<strong>4</strong> obesvarade ansökningar.
						</p>
					</div>
					<div
						className="tile kpi"
						style={{ backgroundColor: "#dfeffb" }}
						onClick={() => navigate(routes.reportsTime)}
					>
						<div className="fig-row">
							<div className="fig">
								<Clock />
							</div>
							<h2>Tidrapporter</h2>
						</div>
						<p>
							Det finns <strong>3</strong> tidrapporter att attestera.
						</p>
					</div>
				</div>

				<div className="tile-row">
					<div className="tile">
						<h2>Information från BILDA</h2>
						<p>
							Just nu är det många skolor som efterfrågar vikarier. Det är därför av extra vikt att försöka vara ute i
							god tid med din beställning. Tänk på att du när som helst på dygnet kan lägga din beställning i den här
							kundportalen och att beställningen då direkt behandlas. Vår växel är också öppen 06.00 – 20.00.
						</p>
						<Link to="" className="tile-action">
							Läs mer
						</Link>
					</div>
					<div className="tile">
						<h2>Skapa uppdrag</h2>
						<p>
							Ett uppdrag skapas digitalt genom att typ av tjänst anges tillsammans med annan uppdragsinformation (fri
							text) och att tiderna för de aktuella arbetspassen skrivs in.
						</p>
						<p>
							I samband med att ett uppdrag skapas finns även möjlighet att önska en eller flera särskilda vikarier.
						</p>
						<Link to={routes.jobCreate} className="tile-action">
							Skapa uppdrag
						</Link>
					</div>
				</div>

				<div className="tile-row">
					<div className="tile">
						<h2>Glöm inte</h2>
						<p>
							Efter avslutat uppdrag (eller efter avslutad vecka vid längre uppdrag) rapporterar konsulterna in sina
							arbetade tider. Glöm inte att gå in och attestera tiderna samt justera ev. rapporterade tider så att det
							blir rätt på de kommande fakturorna.
						</p>
						<p>
							I konsultrapporterna skriver konsulterna bl.a. vad de har arbetat med under arbetspasset och här finns
							även ev. ytterligare information / händelser om uppdraget rapporterade. (Rapporterna skickas till
							kontaktpersonen.)
						</p>
					</div>
				</div>
			</Styles>
		</LoggedInLayout>
	);
};

export default StartPage;

const Styles = styled.div`
	.tile {
		border: 1px solid ${(props) => props.theme.colors.dividerLight};
		border-radius: 10px;
		padding: 1.25rem 1.5rem 2.5rem 1.5rem;
		margin: 0 0.8rem;
		flex: 1;
		background: white;
		position: relative;

		h2 {
			font-weight: 600;
			font-size: 1.15rem;
			margin-top: 0;
		}

		.tile-action {
			position: absolute;
			right: 1rem;
			bottom: 1rem;
			border: 1px solid ${(props) => props.theme.colors.dividerLight};
			padding: 8px 12px;
			border-radius: 12px;
			text-decoration: none !important;
			font-weight: 600;
			font-size: 0.8rem;
			color: ${(props) => props.theme.colors.brand};
		}

		&.kpi {
			display: flex;
			flex-direction: column;
			background-color: ${(props) => props.theme.colors.secondaryBrand};
			cursor: pointer;

			h2 {
				font-size: 1rem;
				margin: 0;
			}
			p {
				font-size: 0.9rem;
				margin-top: 0.75rem;
			}

			.fig-row {
				display: flex;
				align-items: center;
			}

			.fig {
				margin: 0 0.75rem 0 0;
			}

			transition: transform 0.125s;

			&:hover {
				transform: scale(1.05);
			}
		}
	}

	.tile-row {
		margin: 1.75rem -0.8rem 1.75rem -0.8rem;
		display: flex;
	}
`;

function Briefcase26() {
	return (
		<svg height="32" width="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
			<g fill="#333" stroke="#333" strokeLinecap="square" strokeLinejoin="miter" strokeMiterlimit="10" strokeWidth="2">
				<polyline fill="none" points=" 11,7 11,2 21,2 21,7 " />
				<polyline fill="none" points="30,26 30,30 2,30 2,26 " stroke="#333" />
				<rect height="16" width="30" fill="none" stroke="#333" x="1" y="7" />
				<rect height="6" width="12" fill="none" x="10" y="12" />
			</g>
		</svg>
	);
}

function PersonalTrainer() {
	return (
		<svg height="32" width="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
			<g
				fill="#000000"
				stroke="#000000"
				strokeLinecap="square"
				strokeLinejoin="miter"
				strokeMiterlimit="10"
				strokeWidth="2"
			>
				<line fill="none" stroke="#000000" strokeLinecap="butt" x1="10" x2="10" y1="14.182" y2="31" />
				<line fill="none" stroke="#000000" strokeLinecap="butt" x1="22" x2="22" y1="14.182" y2="31" />
				<line fill="none" x1="16" x2="18" y1="19" y2="19" />
				<path
					d="M25,25l2.6-4.33a1,1,0,0,0-.15-1.222l-4.862-4.862A2,2,0,0,0,21.172,14H10.828a2,2,0,0,0-1.414.586L4.552,19.448A1,1,0,0,0,4.4,20.67L7,25"
					fill="none"
					stroke="#000000"
				/>
				<circle cx="16" cy="6" fill="none" r="4" stroke="#000000" />
			</g>
		</svg>
	);
}
